<h2 mat-dialog-title>Add Contract</h2>

<mat-dialog-content>
  <div class="contract-dialog-form br-flex br-flex-column br-gap-1 br-mt-1">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Transaction Code</mat-label>
      <mat-select [(ngModel)]="form.transactionCodeId">
        <mat-option value="">— Select —</mat-option>
        <mat-option *ngFor="let tc of data.transactionCodes" [value]="tc.id">{{ tc.shortDescription }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Price</mat-label>
      <input matInput type="number" [(ngModel)]="form.price" min="0" step="0.01" [placeholder]="selectedTcDefault()" />
    </mat-form-field>

    <div class="br-flex br-gap-3">
      <app-date-field class="br-flex-grow-1 br-min-w-0" label="Effective From *" [(ngModel)]="form.effectiveFrom"></app-date-field>
      <app-date-field class="br-flex-grow-1 br-min-w-0" label="Effective To *" [(ngModel)]="form.effectiveTo" [disabled]="form.noExpiry"></app-date-field>
    </div>
    <mat-checkbox [(ngModel)]="form.noExpiry" (change)="onNoExpiryChange()" class="br-block br-mb-2">No expiry date</mat-checkbox>
    <p *ngIf="!canCreate()" class="contract-dialog-guidance br-m-0 br-mb-2">
      Select a transaction code and set an end date (or check “No expiry date”) to create the draft.
    </p>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>PO Release #</mat-label>
      <input matInput [(ngModel)]="form.poReleaseNumber" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Signed Document URL</mat-label>
      <input matInput [(ngModel)]="form.signedDocumentUrl" />
    </mat-form-field>

    <div class="br-mb-2">
      <p class="contract-dialog-section-label">Allowed Self-Service Modifications</p>
      <mat-checkbox *ngFor="let t of modTypes" class="contract-dialog-option"
                    [checked]="isModTypeEnabled(t)" (change)="toggleModType(t)">
        {{ modTypeLabels[t] }}
      </mat-checkbox>
    </div>

    <div class="br-flex br-gap-3">
      <mat-form-field appearance="outline" class="br-flex-grow-1 br-min-w-0">
        <mat-label>Billing Method</mat-label>
        <mat-select [(ngModel)]="form.billingMethod">
          <mat-option value="PerService">Per Service</mat-option>
          <mat-option value="FlatMonthly">Flat Monthly</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="br-flex-grow-1 br-min-w-0">
        <mat-label>Billing Day of Month</mat-label>
        <input matInput type="number" [(ngModel)]="form.billingDayOfMonth" min="1" max="28" />
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Contract Title</mat-label>
      <input matInput [(ngModel)]="form.title" maxlength="255"
             placeholder="Auto-generated from service + customer if left blank" />
    </mat-form-field>

    <div class="br-flex br-items-center br-justify-between br-my-1">
      <label class="br-form-label">Terms &amp; Conditions</label>
      <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm"
              *ngIf="!data.deferred" (click)="loadStandardTerms()" [disabled]="loadingTerms">
        <br-icon>description</br-icon> {{ loadingTerms ? 'Loading…' : 'Standard terms' }}
      </button>
      <span *ngIf="data.deferred" class="br-small br-text-muted">Standard terms fill in automatically on create.</span>
    </div>
    <mat-form-field appearance="outline" class="full-width">
      <textarea matInput [(ngModel)]="form.terms" rows="10"
                placeholder="Click 'Standard terms' to prefill, or leave blank to auto-generate on create."></textarea>
    </mat-form-field>

    <div *ngIf="error" class="br-small br-text-danger">{{ error }}</div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="br-gap-2">
  <button type="button" class="br-btn br-btn--outline-secondary" (click)="cancel()">Cancel</button>
  <button type="button" class="br-btn br-btn--primary" (click)="create()" [disabled]="saving || !canCreate()">
    {{ saving ? 'Creating…' : 'Create as Draft' }}
  </button>
</mat-dialog-actions>
